import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import { Building2, Megaphone, Wallet, Flame } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const abs = (u) => (!u || u.startsWith("http") ? u : `${BACKEND_URL}${u}`);
const ago = (iso) => {
  const d = Math.round((Date.now() - new Date(iso).getTime()) / 86400000);
  return d <= 0 ? "today" : d === 1 ? "yesterday" : `${d}d ago`;
};

export function BrandsActiveStrip() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/explore/brands-active").then((r) => setData(r.data)).catch(() => setData({ brands: [], totals: {} })); }, []);
  if (!data || data.brands.length === 0) return null;
  const t = data.totals || {};
  return (
    <section className="rounded-2xl bg-[#0C0C10] hairline p-5 space-y-4" data-testid="brands-active-strip">
      <div className="flex items-center justify-between gap-3 flex-wrap">
        <div className="flex items-center gap-2 text-xs uppercase tracking-widest text-zinc-400">
          <Flame className="h-3.5 w-3.5 text-nexus-pink" /> Brands active in the last {t.days || 14} days
        </div>
        <div className="flex items-center gap-4 text-xs text-zinc-400">
          <span className="inline-flex items-center gap-1.5" data-testid="brands-active-campaigns"><Megaphone className="h-3.5 w-3.5 text-nexus-blue" /> <b className="text-white">{t.campaigns || 0}</b> briefs posted</span>
          <span className="inline-flex items-center gap-1.5" data-testid="brands-active-deals"><Wallet className="h-3.5 w-3.5 text-emerald-300" /> <b className="text-white">{t.deals_funded || 0}</b> deals funded</span>
        </div>
      </div>
      <div className="flex gap-3 overflow-x-auto pb-1 -mx-1 px-1" data-testid="brands-active-list">
        {data.brands.map((b) => (
          <Link key={b.brand_id} to="/campaigns" className="shrink-0 w-40 p-3 rounded-xl bg-white/[0.03] hairline hover:border-white/20 transition-colors" data-testid={`brands-active-${b.brand_id}`}>
            <div className="h-12 w-12 rounded-xl bg-white flex items-center justify-center overflow-hidden mb-2">
              {b.logo_url ? <img src={abs(b.logo_url)} alt={b.name} className="w-full h-full object-contain p-1" /> : <Building2 className="h-5 w-5 text-zinc-500" />}
            </div>
            <div className="font-semibold text-sm text-white truncate">{b.name}</div>
            <div className="text-[11px] text-zinc-500 mt-0.5">
              {b.campaigns > 0 && `${b.campaigns} brief${b.campaigns > 1 ? "s" : ""}`}
              {b.campaigns > 0 && b.deals_funded > 0 && " · "}
              {b.deals_funded > 0 && `${b.deals_funded} funded`}
            </div>
            <div className="text-[10px] uppercase tracking-widest text-zinc-600 mt-1">active {ago(b.last_active)}</div>
          </Link>
        ))}
      </div>
    </section>
  );
}
